import { on } from 'delegated-events'
import scrollTo from '@common/scroll-to'

const ignorePageTypes = []

const handleScroll = (event, el) => {
  let targetSelector = null

  if (el.dataset.scroll) {
    targetSelector = el.dataset.scroll
  } else if (el.tagName === 'A') {
    targetSelector = el.hash
  } else {
    return
  }

  if (targetSelector) {
    const target = document.querySelector(targetSelector)
    let offset = 0

    if (target) {
      event.preventDefault()

      // Deactivate navigation menu if active
      document.documentElement.classList.remove('js-site-menu-open')

      scrollTo(target, offset)
    }
  }
}

const handleUrl = () => {
  const shouldIgnore = Array.from(document.body.classList).some((x) => ignorePageTypes.includes(x))

  if (shouldIgnore) {
    return
  }

  if (window.location.hash) {
    let targetSelector = window.location.hash

    let target = document.querySelector(targetSelector)

    if (target) {
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 10)

      setTimeout(() => {
        scrollTo(target)
      }, 250)
    }
  }
}

// Automatically scrolls to the first element with the [data-scrolltome] attribute
const handleScrollToMe = () => {
  const target = document.querySelector('[data-scrolltome]')

  if (target) {
    setTimeout(() => {
      scrollTo(target)
    }, 250)
  }
}

export default {
  init: () => {
    on('click', '[data-scroll]', (event) => {
      const el = event.target.closest('[data-scroll]')

      handleScroll(event, el)
    })

    // Handle any custom anchor tags
    on('click', '.wysiwyg a[href*="#"]:not(.ignore-scroll)', (event) => {
      const el = event.target.closest('a')

      handleScroll(event, el)
    })

    handleUrl()
    handleScrollToMe()
  },
}
